import { Link } from 'react-router-dom';
import type { Patient, Exam } from '@/lib/types';
import { statusLabel, examCountLabel } from '@/lib/ui';
import { ChevronRightIcon } from '@/components/ui/Icons';

interface PatientCardProps {
  patient: Patient;
  exams: Exam[];
}

const scoreText = {
  ok: 'text-ok-deep',
  warn: 'text-warn-deep',
  crit: 'text-crit-deep',
} as const;

const badgeColor = {
  ok: 'bg-ok-tint text-ok-deep',
  warn: 'bg-warn-tint text-warn-deep',
  crit: 'bg-crit-tint text-crit-deep',
} as const;

export function PatientCard({ patient: p, exams }: PatientCardProps) {
  const lastExam = exams[0];
  const lastExamLabel = lastExam
    ? `${parseInt(lastExam.collectedDay, 10)} ${lastExam.collectedMonth.toLowerCase()}`
    : 'sin exámenes';

  return (
    <Link
      to={`/patients/${p.id}`}
      className="flex items-center gap-3.5 px-5 py-3 border-b border-line last:border-b-0 transition-colors hover:bg-hover max-[760px]:px-4 max-[760px]:py-2.5 max-[760px]:gap-3"
    >
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold tracking-[-0.005em] mb-px max-[760px]:text-[13px]">
          {p.name}
        </div>
        <div className="text-xs text-tertiary">
          {p.age} años · {p.gender} · {p.city}
        </div>
        <div className="text-[11px] text-muted mt-0.5">
          {examCountLabel(exams.length)} · Último: {lastExamLabel}
        </div>
      </div>
      <div className="flex items-center gap-3.5 shrink-0">
        <div className="text-right leading-tight">
          <strong className={`block text-[17px] font-bold tracking-[-0.02em] tnum leading-none ${scoreText[p.status]}`}>
            {p.optimalScore}
          </strong>
          <span className={`inline-block text-[10px] font-semibold tracking-[0.02em] px-1.5 py-0.5 rounded-sm mt-1 max-[760px]:hidden ${badgeColor[p.status]}`}>
            {statusLabel[p.status]}
          </span>
        </div>
      </div>
      <ChevronRightIcon className="w-3 text-faint shrink-0" />
    </Link>
  );
}
